export default __webpack_public_path__ + "static/media/thumbnail.654f04ce.png";